import type { ConfigType } from '@plone/registry';
import FileView from 'cmuberlandia-portal/components/Views/FileView';
import LinkView from '@plone/volto/components/theme/View/LinkView';

export default function install(config: ConfigType) {
  // Views
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    File: FileView,
    Link: LinkView,
  };
  return config;
}
